import * as React from 'react';

import { useChatPageMessages } from './hooks/useChatPageMessages';
import { ChatPageLayout } from '../../components/ChatPageLayout';
import { ChatPrettyDate } from '../../components/ChatPrettyDate';
import { TMessage } from '../../types/messages';
import { IMessagePage } from '../../utils/messageUtils';
import { useMergeOfferMessages } from './hooks/useMergeOfferMessages';
import { useApplicationContext } from '../../utils/applicationContext';

type TProps = {
  page: IMessagePage;
  setRefInMessagesMap: (r: HTMLDivElement | null, message: TMessage, messageId: string) => void;
  unreadRef: React.RefObject<HTMLDivElement>;
};

export const ChatPageContainer: React.FC<TProps> = ({ page, setRefInMessagesMap, unreadRef }) => {
  const { config } = useApplicationContext();
  const horizontalGalleryOffersView = config.get<string>('frontend-chats.horizontalGalleryOffers.Enabled') ?? false;

  const { date, messages } = page;

  /* eslint-disable */
  const { mergedMessages } = horizontalGalleryOffersView
    ? useMergeOfferMessages(messages)
    : { mergedMessages: messages };

  const { messagesNode } = useChatPageMessages(mergedMessages, setRefInMessagesMap, unreadRef);

  return <ChatPageLayout key={`chat_page_${date}`} date={<ChatPrettyDate date={date} />} messages={messagesNode} />;
};
